import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

import { HoldingClass, Share } from 'types';

type Props = {
  share: Share;
  affectedShares: number;
};

const ShareEncumbranceViewFormReadOnlyData: FC<Props> = ({
  share,
  affectedShares,
}) => {
  const { t } = useTranslate();

  const className = (share?.shareClass as HoldingClass)?.name || '';

  return (
    <>
      <div className="col-3">
        <div className="form-group">
          <label className="form-label" htmlFor="encumbrance-affected-shares">
            {t('AffectedShares')}
          </label>
          <div className="form-control-wrap">
            <input
              type="text"
              id="encumbrance-affected-shares"
              className="form-control form-control-md"
              value={affectedShares}
              readOnly
            />
          </div>
        </div>
      </div>

      <div className="col-3">
        <div className="form-group">
          <label className="form-label" htmlFor="encumbrance-class">
            {t('EncumbranceClass')}
          </label>
          <div className="form-control-wrap">
            <input
              type="text"
              id="encumbrance-calss"
              className="form-control form-control-md"
              value={className}
              readOnly
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ShareEncumbranceViewFormReadOnlyData;
